export default "__VITE_ASSET__DDBZErhT__"